<div class="toolbar-user" (prepClickOutside)="onClickOutside()" fxFlex="grow">
  <!-- Toggle Button for Resource Menu -->
  <button id="resource-menu-button" class="button" mat-button (click)="toggleDropdown()" [class.open]="isOpen" fxFlex="grow"
    aria-label="Resource Menu" [matTooltip]="LangTextData.tooltipLabel.resourceMenu"
    matTooltipClass="table_tooltip_job_filename" matTooltipPosition="below" aria-haspopup="true"
    [attr.aria-expanded]="isOpen" aria-controls="resource-menu" type="button">
    <span fxLayout="row" fxLayoutAlign="start center" style="color: #136ef8;">
      <mat-icon aria-hidden="true">video_library</mat-icon>
      &nbsp;&nbsp;<strong>{{LangTextData.htmlLabel.resourceText}}</strong>
    </span>
  </button>
  <!-- -->
  <!-- Dropdown Menu -->
  <div *ngIf="isOpen" class="dropdown" [class.open]="isOpen" id="resource-menu" role="menu"
    aria-label="User dropdown menu" (focusout)="onFocusOut($event)"
    style="  background-color: #f9f9f9;">
    <div class="content">
      <div class="list">
        <!-- Profile Menu Item -->
        <div class="list-item" matRipple role="menuitem" tabindex="0" (click)="clickGoToTraning()"
          (keydown.enter)="clickGoToTraning()" (keydown.space)="clickGoToTraning()" [aria-label]="LangTextData.htmlLabel.resourceTutorial">
          <mat-icon class="list-item-icon" aria-hidden="true">open_in_new</mat-icon>
          <span class="youtube_link">{{LangTextData.htmlLabel.resourceTutorial}}</span>
        </div>
        <mat-divider></mat-divider>
        <!-- Logout Menu Item -->
        <div class="list-item" matRipple role="menuitem" tabindex="0" (click)="clickGoTpQuickStartGuide()"
          (keydown.enter)="clickGoTpQuickStartGuide()" (keydown.space)="clickGoTpQuickStartGuide()"
          [aria-label]="LangTextData.htmlLabel.resourceOnboardDoc">
          <mat-icon class="list-item-icon" aria-hidden="true">open_in_new</mat-icon>
          <span class="youtube_link">{{LangTextData.htmlLabel.resourceOnboardDoc}}</span>
        </div>
        <mat-divider></mat-divider>
        <div class="list-item" matRipple role="menuitem" tabindex="0"
          (click)="$event.stopPropagation(); toggleSubmenu()"
          (keydown.enter)="$event.stopPropagation(); toggleSubmenu()"
          (keydown.space)="$event.stopPropagation(); toggleSubmenu()" [aria-label]="LangTextData.htmlLabel.resourceVideo">
          <mat-icon class="list-item-icon" aria-hidden="true">video_file</mat-icon>
          <span>{{LangTextData.htmlLabel.resourceVideo}}</span>
          <!-- Submenu Trigger -->
          <div class="submenu-trigger">
            <mat-icon aria-hidden="true">arrow_drop_down</mat-icon>
          </div>
        </div>
        <!-- Submenu -->
        <div class="submenu" *ngIf="isSubmenuOpen">
          <div class="submenu-item" matRipple role="menuitem" tabindex="0" (click)="clickSubmenuItem('item1')">
            <mat-icon class="submenu-item-icon" aria-hidden="true">open_in_new</mat-icon>
            <span class="youtube_link">{{LangTextData.htmlLabel.resourceVideoSubmenuItem1}}</span>
          </div>
          <mat-divider></mat-divider>
          <div class="submenu-item" matRipple role="menuitem" tabindex="0" (click)="clickSubmenuItem('item2')">
            <mat-icon class="submenu-item-icon" aria-hidden="true">open_in_new</mat-icon>
            <span class="youtube_link">{{LangTextData.htmlLabel.resourceVideoSubmenuItem2}}</span>
          </div>
          <mat-divider></mat-divider>
          <div class="submenu-item" matRipple role="menuitem" tabindex="0" (click)="clickSubmenuItem('item3')">
            <mat-icon class="submenu-item-icon" aria-hidden="true">open_in_new</mat-icon>
            <span class="youtube_link">{{LangTextData.htmlLabel.resourceVideoSubmenuItem3}}</span>
          </div>
          <mat-divider></mat-divider>
          <div class="submenu-item" matRipple role="menuitem" tabindex="0" (click)="clickSubmenuItem('item4')">
            <mat-icon class="submenu-item-icon" aria-hidden="true">open_in_new</mat-icon>
            <span class="youtube_link">{{LangTextData.htmlLabel.resourceVideoSubmenuItem4}}</span>
          </div>
          <mat-divider></mat-divider>
          <div class="submenu-item" matRipple role="menuitem" tabindex="0" (click)="clickSubmenuItem('item5')">
            <mat-icon class="submenu-item-icon" aria-hidden="true">open_in_new</mat-icon>
            <span class="youtube_link">{{LangTextData.htmlLabel.resourceVideoSubmenuItem5}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>